<template> 
    <div class="page-main">
        <Banner :displayHomeButton="true" :displayProfileButton="true"></Banner>
        <div class="main-title">{{childName}}</div>
        <v-row justify="center" no-gutters>
            <v-col cols="11">
                <router-view style="padding-bottom: 100px;" ref="child"></router-view>
            </v-col>
        </v-row>
        <Footer v-if="this.$route.name != 'profile.home'" saveBottonText="SAVE" :saveToPush="{name: 'profile.home'}" :backToPush="{name: 'profile.home'}" :saveToValidate="validate" :saveToSubmit="submit"/>
    </div>
</template>
<script>
import Banner from './BannerComponent';
import Client from '../client.js';
import Footer from "./SaveOrBackComponent";

export default {
    components: {
        Banner,
        Footer
    },
    data() {
        return {
            childName: ' ',
            items: [
                {
                    title: 'My Personal Details', 
                    desc: `Your personal details including address, email, mobile phone, allergies and t-shirt size.`,
                    label: 'EDIT',
                    route: 'profile.me',
                    img: '/profile_myDetails.svg',
                },
                {
                    title: 'My Heritage', 
                    desc: `Your strength and identity. We put culture at the heart of everything we do so who you are is important.`,
                    label: 'EDIT',
                    route: 'profile.heritage',
                    img: '/profile_myHeritage.svg',
                },
                {
                    title: 'My School', 
                    desc: `Your current school details and where you are applying for a scholarship.`,
                    label: 'EDIT',
                    route: 'profile.school',
                    img: '/profile_mySchool.svg',
                },
                {
                    title: 'My Family', 
                    desc: `Your primary guardian, emergency contact and a bit about your family.`,
                    label: 'EDIT',
                    route: 'profile.family',
                    img: '/profile_myFamily.svg',
                },
            ],
            profile: undefined,
        };
    },
    async beforeMount() {
        let client = Client();
        client.get('me/profile').then(res => {
            this.profile = res.data;
            //console.log('me/profile'+res.data);
            //console.log(res.data);
            this.prepareschool();
        }, () => {})      
    },
    mounted() {
        this.fetchScholarships();
        
    },
    methods: {
        fetchScholarships() {
            const client = Client();
            client.get('me/history_applications').then(res => {
                // const pastApplications = res.data.filter(s => {
                //     return ['Successful','Unsuccessful','Incompleted'].includes(s['Scholarship_Application__c.Status__c']);
                // });
                if(res.data.length > 0) {
                    this.items.push({
                        title: 'My GO HISTORY', 
                        desc: `Your application history.`,
                        label: 'VIEW',
                        route: 'history',
                        img: '/profile_myGOhistory.svg',
                    })
                }
            }, () => {})
        },
        goto(route) {
            this.$router.push({
                name: route,
            });
        },
        validate() {
            const result = this.$refs.child.$refs.form.validate();
            if(!result) {
                setTimeout(() => {
                    const el = document.getElementsByClassName('error--text')[0];
                    el && el.scrollIntoView({behavior: 'smooth'});
                }, 0)
            }
            return result;
        },
        async submit() {
            return await this.$refs.child.submit()
        },
        async prepareschool(){
            if(this.profile.schoollevel == 'primary'){
                this.$store.dispatch('school/fetchAllPrimarySchools');
                this.$store.dispatch('school/fetchPrimaryPublicSchools');
                this.$store.dispatch('school/fetchPrimaryindependentSchools');
            }else if(this.profile.schoollevel == 'high'){
                this.$store.dispatch('school/fetchSchools');
                this.$store.dispatch('school/fetchActiveSchools');
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.main-title {
    font-family: $body-font-family;
    font-size: 30px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 4px;
    text-align: center;
    margin: 30px 0;
}
.sub-title {
    font-family: $body-font-family;
    font-size: 24px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 3.2px;
    text-align: center;
    margin-bottom: 20px;
}
.card-desc {
    font-family: $secondary-font;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
}
.button {
    width: 100%;
    color: white;
    font-family: $btn-font;
    margin-bottom: 30px;
}
.card {
    border: solid 1px #a5a5a5;
    background-color: #ffffff;
    padding: 20px;
    display: flex;
    align-items: center;
}
.card-middle {
    font-family: $secondary-font;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    flex: 1;
}
.card-icon {
    margin-right: 30px;
    width: 48px;
    height: 48px;
    filter: invert(43%) sepia(26%) saturate(2535%) hue-rotate(343deg) brightness(90%) contrast(88%);
}
.card-title {
    font-family: $body-font-family;
    font-size: 20px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: 2.67px;
    margin-bottom: 12px;
}
.card-btn {
    color: white;
    flex-basis: 20%;
    margin-left: 20px;
    font-family: $btn-font;
}

</style>
